import { supabase } from './supabase';

interface ContactMessage {
  name: string;
  email: string;
  message: string;
}

export async function sendContactMessage(data: ContactMessage) {
  const { error } = await supabase
    .from('contact_messages')
    .insert([{
      name: data.name,
      email: data.email,
      message: data.message,
      status: 'unread'
    }]);

  if (error) {
    throw new Error('Failed to send message. Please try again later.');
  }

  return { success: true };
}